exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-contact-tsx": () => import("./../../../src/pages/contact.tsx" /* webpackChunkName: "component---src-pages-contact-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-internship-tsx": () => import("./../../../src/pages/internship.tsx" /* webpackChunkName: "component---src-pages-internship-tsx" */),
  "component---src-pages-wms-tsx": () => import("./../../../src/pages/wms.tsx" /* webpackChunkName: "component---src-pages-wms-tsx" */)
}

